import { render } from "./CldrRows.vue?vue&type=template&id=6afa3ed3"
import script from "./CldrRows.vue?vue&type=script&lang=js"
export * from "./CldrRows.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__